import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getCommercialSocietyType from '../../services/entity/getCommercialSocietyType'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCommercialSocietyTypeComboSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchCommercialSocietyTypeCombo () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const CSTCombo = yield call(getCommercialSocietyType, auth.token)
    yield put(fetchCommercialSocietyTypeComboSuccess(CSTCombo))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchCommercialSocietyTypeCombo () {
  yield takeLatest(combosActionTypes.FETCH_COMMERCIAL_SOCIETY_TYPE_COMBO, fetchCommercialSocietyTypeCombo)
}
